import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { map, Observable } from 'rxjs';
import { IKeyValuePair } from '@interfaces/IKeyValuePair';
import { CompanySoftwareOptionsState, CompanySoftwareOptionsStore } from './cswo-store';
import { AppConfigService } from 'app/services/appConfig/appConfigService';
import { SoftwareOptionsForCompany } from '@shared/enums';

@Injectable({ providedIn: 'root' })
export class CompanySoftwareOptionsQuery extends Query<CompanySoftwareOptionsState> {
	companySoftwareOptions$: Observable<IKeyValuePair> = this.select(state => state.companySoftwareOptions);

	constructor(
		protected store: CompanySoftwareOptionsStore,
		private readonly appConfigService: AppConfigService
	) {
		super(store);
	}

	/** Emits true whenever the currently loaded company has the given software option. */
	hasSoftwareOption$(swo: SoftwareOptionsForCompany): Observable<boolean> {
		return this.companySoftwareOptions$.pipe(map(swos => !!swos[swo]));
	}

	get isCswoUpdated() {
		const lastUpdateTime = new Date(this.getValue().lastUpdate).getTime();
		const timeNow = new Date().getTime();
		const shouldFetch = !this.getValue().lastUpdate || timeNow - lastUpdateTime > this.appConfigService.appSettings.cachingTimeout;
		return Object.keys(this.getValue().companySoftwareOptions).length > 0 && !shouldFetch;
	}
}
